import { Chain } from '@ankr.com/chains-list';
import { useMemo } from 'react';

import { selectPublicChainById } from 'modules/chains/store/selectors';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAppSelector } from 'store/useAppSelector';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';

import { getNetworkParams } from '../utils/getNetworkParams';

interface UseNetworkConfigProps {
  chain: Chain;
}

export const useNetworkConfig = ({ chain }: UseNetworkConfigProps) => {
  const { isLoggedIn } = useAuth();
  const { isEnterprise } = useAccountStatus();

  const publicChain = useAppSelector(state =>
    selectPublicChainById(state, chain.id),
  );

  const { chainSubType, chainType, group } = useChainSelectors();

  const { networkConfiguration } = useMemo(
    () =>
      getNetworkParams({
        chain: isLoggedIn ? chain : publicChain || chain,
        chainSubType,
        chainType,
        group,
        isEnterprise,
      }),
    // no need to track chainType
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chain, publicChain, chainSubType, group, isLoggedIn, isEnterprise],
  );

  return networkConfiguration;
};
